export default __webpack_public_path__ + "static/media/treasury.b173fff5.svg";